import React from "react";
import { motion } from "framer-motion";
import stockdashboard from "../assets/stockdashboard_project.png";

const Card4 = () => {
  return (
    <motion.div
      initial={"hidden"}
      whileInView={"visible"}
      variants={{
        visible: { opacity: 1 },
        hidden: { opacity: 0 },
      }}
      className="max-w-xl bg-white rounded-lg border border-gray-200 shadow-lg bg-gray-100 dark:border-gray-700 my-8"
    >
      <a href="https://stock-dashboard-theta.vercel.app/" target="_blank" rel="noopener noreferrer">
        <img
          className="rounded-t-lg w-full"
          src={stockdashboard}
          alt="Stock Price Dashboard project home page"
        />
      </a>
      <div className="p-5">
        <a href="https://github.com/nick3948/stock-dashboard" target="_blank" rel="noopener noreferrer">
          <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-black hover:text-blue-500 transition-colors duration-300 cursor-pointer">
            Stock Price Dashboard
          </h5>
        </a>
        <p className="mb-3 font-normal text-gray-700 dark:text-black-400">
          Designed and developed a stock price visualization dashboard using React and Chart.js to display real-time price trends for selected companies. Integrated live data fetching, dynamic charting features, and ensured a responsive design for seamless user experience across devices.
        </p>
      </div>
    </motion.div>
  );
};

export default Card4;